import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Datetime from 'react-datetime';
import { Form, Button, Modal, Alert, ButtonGroup } from 'react-bootstrap';
import { createEquipmentGroup, editEquipmentGroup, equipmentGroupClear } from '../../actions/equipment-group';
import { getEquipmentNameList, getDeviceList } from '../../actions/equipment';
import { getOperatorList } from '../../actions/person';
import { refreshMapData } from '../../actions/map';
import { FormValidator } from '../../helpers/form-validator';
import { getUTC, toApiDateString, toMoment, getLocalDate } from '../../helpers/moment-ex';
import { getUserId } from '../../helpers/session';
import { EQUIPMENT_TRACTOR, DISPLAY_DATE_FORMAT, EQUIPMENT_SELF_PROPELLED } from '../../constants';
import { Aux, Icon, Heading6, Validator, TitleIcon } from '../widgets';
import { updateChatEGList } from '../../actions/chat';
import "../../../assets/css/react-datetime.css";

const ModeTypeButtonGroup = ({ activeKey, children, onSelect, disabled }) => {
	const childrens = React.Children.map(children, (child) => {
		if (child.props.hasOwnProperty("eventkey")) {
			return React.cloneElement(child, {
				variant: (parseInt(activeKey) === parseInt(child.props.eventkey)) ? 'primary' : 'default',
				onClick: () => onSelect(child.props.eventkey),
				disabled
			});
		}
		return child;
	});

	return <ButtonGroup size="sm" toggle={true} className="mb-2">
		{childrens}
	</ButtonGroup>
}

class EquipmentGroupForm extends React.Component {
	constructor() {
		super();
		this.bindValues = this.bindValues.bind(this);
		this.getValidationRules = this.getValidationRules.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handlePrimaryEquipment = this.handlePrimaryEquipment.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.saveResource = this.saveResource.bind(this);
		this.clearAlert = this.clearAlert.bind(this);
		this.disposeForm = this.disposeForm.bind(this);
		this.validator = this.getValidationRules();
		this.submitted = false;

		this.initialState = {
			farmId: null,
			name: "",
			modeTypeId: 1,
			vehicleEquipmentId: null,
			implementEquipmentId: null,
			phoneDeviceId: null,
			canDeviceId: null,
			operatorId: null,
			startDate: "",
			isImplement: true,
			isCanDevice: true,
			isManualName: false,
			validation: this.validator.valid()
		};
		this.state = this.initialState;
	}

	getValidationRules() {
		const isSelect = (value) => { return (value === null) || (value === ""); }
		const isOptional = () => { return false; };

		return new FormValidator([
			{
				field: 'vehicleEquipmentId',
				method: isSelect,
				validWhen: false,
				message: 'Please select vehicle'
			},
			{
				field: 'implementEquipmentId',
				method: isOptional,
				validWhen: false,
				message: 'Please select implement'
			},
			{
				field: 'phoneDeviceId',
				method: isOptional,
				validWhen: false,
				message: 'Please select phone device'
			},
			{
				field: 'canDeviceId',
				method: isOptional,
				validWhen: false,
				message: 'Please select can device'
			},
			{
				field: 'operatorId',
				method: isOptional,
				validWhen: false,
				message: 'Please select operator'
			},
			{
				field: 'startDate',
				method: isSelect,
				validWhen: false,
				message: 'Please select kick-off date'
			},
			{
				field: 'name',
				method: 'isEmpty',
				validWhen: false,
				message: 'Name is required'
			}
		])
	}

	componentDidMount() {
		const { farmId } = this.props.match.params;
		this.setState({ startDate: getUTC().tz(this.props.timezoneIdentifier), farmId });
		this.bindValues(this.props);
	}

	componentDidUpdate(prevProps) {
		if (this.props.editKey !== prevProps.editKey && this.props.equipmentGroupInfo)
			this.bindValues(this.props);
	}

	bindValues(props) {
		let equipmentGroupId = '', phoneDeviceId = null, canDeviceId = null;
		if (props.isEditMode) {
			this.submitted = false;
			const r = props.equipmentGroupInfo;
			equipmentGroupId = r.equipment_group_uuid;
			phoneDeviceId = r.phone_device.device_uuid ? r.phone_device.device_uuid : null;
			canDeviceId = r.can_device.device_uuid ? r.can_device.device_uuid : null;

			const params = {
				name: r.equipment_group_name,
				modeTypeId: r.equipment_group_mode_id ? r.equipment_group_mode_id : 1,
				vehicleEquipmentId: r.vehicle.equipment_uuid,
				implementEquipmentId: r.implement.equipment_uuid ? r.implement.equipment_uuid : null,
				phoneDeviceId: r.phone_device.device_uuid ? r.phone_device.device_uuid : null,
				canDeviceId: r.can_device.device_uuid ? r.can_device.device_uuid : null,
				operatorId: r.operator.operator_uuid ? r.operator.operator_uuid : null,
				startDate: r.vehicle.start_date ? toMoment(r.vehicle.start_date) : getLocalDate(),
				isImplement: (r.vehicle.equipment_type_id === EQUIPMENT_TRACTOR),
				isCanDevice: (r.vehicle.equipment_type_id === EQUIPMENT_TRACTOR || r.vehicle.equipment_type_id === EQUIPMENT_SELF_PROPELLED),
				validation: this.validator.valid()
			};
			this.setState(params);
		}

		const { farmId } = this.state.farmId ? this.state : this.props.match.params;
		this.props.actions.getVehicleEquipmentList(farmId, equipmentGroupId);
		this.props.actions.getImplementEquipmentList(farmId, equipmentGroupId);
		this.props.actions.getPhoneDeviceList(farmId, phoneDeviceId);
		this.props.actions.getCanDeviceList(farmId, canDeviceId);
		this.props.actions.getOperatorList({ farmId });
	}

	clearAlert() {
		this.props.actions.clear();
	}

	handlePrimaryEquipment(option) {
		const { value, equipmentTypeId } = option ? option : { value: null, equipmentTypeId: 0 };
		this.setState({
			vehicleEquipmentId: value,
			isImplement: (equipmentTypeId === EQUIPMENT_TRACTOR),
			isCanDevice: (equipmentTypeId === EQUIPMENT_TRACTOR || equipmentTypeId === EQUIPMENT_SELF_PROPELLED),
			implementEquipmentId: (equipmentTypeId === EQUIPMENT_TRACTOR) ? this.state.implementEquipmentId : null,
			canDeviceId: (equipmentTypeId === EQUIPMENT_TRACTOR || equipmentTypeId === EQUIPMENT_SELF_PROPELLED) ? this.state.canDeviceId : null,
			name: this.state.isManualName ? this.state.name : option ? option.label : ""
		});
	}

	handleSelect(option, name) {
		const { value } = option ? option : { value: null };
		this.setState({ [name]: value });
	}

	handleChangeDate(keyName, event) {
		this.setState({ [keyName]: event })
	}

	handleChange(event) {
		const { name, value } = event.target;
		if (name === "name") this.setState({ [name]: value, isManualName: (value && value.length > 0) });
		else this.setState({ [name]: value });
	}

	saveResource() {
		const validation = this.validator.validate(this.state);
		this.setState({ validation });
		this.submitted = true;

		if (validation.isValid) {
			const s = this.state;
			const success = () => {
				this.disposeForm();
				this.props.actions.refreshMapData();
				this.props.actions.updateChatEGList(s.farmId);
			};

			const params = {
				farm_uuid: s.farmId,
				name: s.name,
				equipment_group_mode_id: s.modeTypeId,
				vehicle_equipment_uuid: s.vehicleEquipmentId,
				implement_equipment_uuid: s.implementEquipmentId,
				operator_uuid: s.operatorId,
				phone_device_uuid: s.phoneDeviceId,
				can_device_uuid: s.canDeviceId,
				start_date: toApiDateString(s.startDate),
				created_by: getUserId()
			}

			if (!this.props.isEditMode) this.props.actions.createEquipmentGroup(params, success);
			else {
				params.modified_by = getUserId();
				params.equipment_group_uuid = this.props.equipmentGroupInfo.equipment_group_uuid;
				this.props.actions.editEquipmentGroup(params, success);
			}
		}
	}

	disposeForm() {
		this.submitted = false;
		this.setState({ ...this.initialState, validation: this.validator.valid() });
		this.clearAlert();
		this.props.onHide();
	}

	render() {
		const s = this.state;
		const validation = this.submitted ? this.validator.validate(this.state) : this.state.validation;

		return (
			<Modal show={this.props.isOpen} onHide={this.disposeForm} className="modal-form">
				<Form className="eg-form">
					<Modal.Header closeButton>
						<Modal.Title>
							<Heading6>
								<TitleIcon className="fa fa-truck" />
								{this.props.isEditMode ? 'Edit Equipment Group' : 'Add Equipment Group'}
							</Heading6>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body className="py-0">
						{!this.props.save.isSuccess && this.props.save.message &&
							<Alert show={true} onClose={this.clearAlert} variant="danger" dismissible>
								{this.props.save.message}
							</Alert>}

						<ModeTypeButtonGroup title="Mode Type" activeKey={this.state.modeTypeId}
							onSelect={(e) => this.handleSelect({ value: e }, "modeTypeId")} disabled={this.props.isEditMode}>
							<Button eventkey={1}>Vehicle</Button>
							<Button eventkey={2}>Operator</Button>
						</ModeTypeButtonGroup>

						<Form.Group>
							<Validator validation={validation.vehicleEquipmentId}>
								<Form.Label htmlFor="cmbVehicle">Vehicle<Validator.Mand /></Form.Label>
								<Form.Select id="cmbVehicle" placeholder="Choose a vehicle" name="vehicleEquipmentId"
									value={s.vehicleEquipmentId} onChange={this.handlePrimaryEquipment}
									options={this.props.vehicleEquipmentList.map(e => {
										return ({ value: e.equipment_uuid, label: e.equipment_name, equipmentTypeId: e.equipment_type_id });
									})}
									sortType="asc">
								</Form.Select>
								<Validator.Text />
							</Validator>
						</Form.Group>

						<Form.Group>
							<Validator validation={validation.implementEquipmentId}>
								<Form.Label htmlFor="cmbImplement">Implement</Form.Label>
								<Form.Select id="cmbImplement" placeholder="Choose a implement" name="implementEquipmentId"
									value={s.implementEquipmentId} disabled={!s.isImplement}
									onChange={(e) => { this.handleSelect(e, 'implementEquipmentId'); }}
									options={this.props.implementEquipmentList.map(e => {
										return ({ value: e.equipment_uuid, label: e.equipment_name });
									})}
									sortType="asc">
								</Form.Select>
								<Validator.Text />
							</Validator>
						</Form.Group>

						<Aux>
							<Form.Group>
								<Validator validation={validation.name}>
									<Form.Label htmlFor="txtName">Name<Validator.Mand /></Form.Label>
									<Form.Control id="txtName" type="text" placeholder="Enter name" className="form-control" autoComplete="off"
										value={s.name} name="name" onChange={this.handleChange} />
									<Validator.Text />
								</Validator>
							</Form.Group>
						</Aux>

						<Form.Group>
							<Validator validation={validation.phoneDeviceId}>
								<Form.Label htmlFor="cmbPhoneDevice">Phone Device</Form.Label>
								<Form.Select id="cmbPhoneDevice" placeholder="Choose a phone device" name="phoneDeviceId"
									value={s.phoneDeviceId} onChange={(e) => { this.handleSelect(e, 'phoneDeviceId'); }}
									options={this.props.phoneDeviceList.map(e => {
										return ({
											value: e.equipment_uuid ? e.equipment_uuid : e.device_uuid,
											label: e.equipment_name ? e.equipment_name : e.device_name
										});
									})}
									sortType="asc">
								</Form.Select>
								<Validator.Text />
							</Validator>
						</Form.Group>

						{/* <Form.Group>
                            <Validator validation={validation.canDeviceId}>
                                <Form.Label htmlFor="cmbCanDevice">Can Device</Form.Label>
                                <Form.Select id="cmbCanDevice" placeholder="Choose a can device" name="canDeviceId"
                                    value={s.canDeviceId} disabled={!s.isCanDevice} onChange={(e) => { this.handleSelect(e, 'canDeviceId'); }}
                                    options={this.props.canDeviceList.map(e => {
                                        return ({
                                            value: e.equipment_uuid ? e.equipment_uuid : e.device_uuid,
                                            label: e.equipment_name ? e.equipment_name : e.device_name
                                        });
                                    })}>
                                </Form.Select>
                                <Validator.Text />
                            </Validator>
                        </Form.Group> */}

						<Form.Group>
							<Validator validation={validation.operatorId}>
								<Form.Label htmlFor="cmbOperator">Operator</Form.Label>
								<Form.Select id="cmbOperator" placeholder="Choose a operator" name="operatorId"
									value={s.operatorId} onChange={(e) => { this.handleSelect(e, 'operatorId'); }}
									options={this.props.operatorList.map(e => {
										return ({ value: e.person_uuid, label: e.person_name });
									})}
									sortType="asc">
								</Form.Select>
								<Validator.Text />
							</Validator>
						</Form.Group>

						<Form.Group>
							<Validator validation={validation.startDate}>
								<Form.Label htmlFor="dpStartDate">Start Date<Validator.Mand /></Form.Label>
								<Datetime id="dpStartDate" placeholder="Select start date" name="startDate" closeOnSelect={true}
									dateFormat={DISPLAY_DATE_FORMAT} onChange={this.handleChangeDate.bind(this, "startDate")}
									value={this.state.startDate} selected={this.state.startDate} />
								<Validator.Text />
							</Validator>
						</Form.Group>

					</Modal.Body>
					<Modal.Footer>
						<Button size="sm" variant="danger" onClick={this.disposeForm}><Icon className="fa fa-times"></Icon> Cancel</Button>
						<Button size="sm" variant="primary" onClick={this.saveResource}><Icon className="fa fa-floppy-o"></Icon> Save</Button>
					</Modal.Footer>
				</Form>
			</Modal >);
	}
}

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators({
		getVehicleEquipmentList: (farmId, equipmentGroupId) =>
			getEquipmentNameList({ farmId, equipmentType: 'vehicle', equipmentGroupId }),
		getImplementEquipmentList: (farmId, equipmentGroupId) =>
			getEquipmentNameList({ farmId, equipmentType: 'implement', equipmentGroupId }),
		getPhoneDeviceList: (farmId, includeDeviceId) => getDeviceList({ farmId, includeDeviceId, deviceType: 'phone' }),
		getCanDeviceList: (farmId, includeDeviceId) => getDeviceList({ farmId, includeDeviceId, deviceType: 'can' }),
		getOperatorList,
		createEquipmentGroup,
		editEquipmentGroup,
		clear: () => equipmentGroupClear(),
		refreshMapData,
		updateChatEGList
	}, dispatch)
});

const mapStateToProps = state => ({
	timezoneIdentifier: state.farm.currentFarm.timezone_identifier,
	vehicleEquipmentList: state.equipment.vehicleEquipmentList,
	implementEquipmentList: state.equipment.implementEquipmentList,
	phoneDeviceList: state.equipment.phoneDeviceList,
	canDeviceList: state.equipment.canDeviceList,
	save: state.equipmentGroup.save,
	operatorList: state.person.operatorList
});

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentGroupForm);